import styled from "styled-components";

export const WidgetLabel = styled.h6`
    position: relative;
    font-size: 1rem;
    color: #546982;
`;